import React, { useEffect, useState } from 'react';
import '../styles/insights.css';
import Apis from '../services/apis';
import ReactMarkdown from 'react-markdown';

const Insights = () => {
  const [activeStory, setActiveStory] = useState(null);
  const [Allinsights, setAllInsights] = useState([]);
  const [categories, setCategories] = useState([]);
  const [insights, setInsights] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [loading, setLoading] = useState(true);
  const apis = new Apis();
  const [marketNews,setMarketNews] = useState([]);
  const [Allinsights2, setAllInsights2] = useState([]);
  const [categories2, setCategories2] = useState([]);
  const [loading2, setLoading2] = useState(true);
  const [selectedCategory2, setSelectedCategory2] = useState('all');
  const [selType,setSeltype] = useState('reports');
  const [openId, setOpenId] = useState(null);


  const getCategories = async () => {
    try {
      const response = await apis.getCategories();
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        alert("Error occurred while fetching categories " + error.response.data.message);
      } else {
        console.error("Error:", error);
        alert("Error occurred while fetching asset data");
      }
      return [];
    }
  };

  
  useEffect(() => {
    fetch('https://schedulerapi.pricingculture.com/holdings/getinsights')
      .then(res => res.json())
      .then(async(data) => {

        let allcat = await getCategories();

        const mapfun =(data)=>
          {
              if(data == "ALL"){
                return "ALL"
              }
              if(data == "NFT"){
                return "NFT"
              }
              if(data == "ART"){
                return "ART"
              }
              if(data == "COLLECTIBLES"){
                return "SECURITIZED COLLECTIBLES"
              }
              if(data == "WATCHES"){
                return "LUXURY TIMEPIECES"
              }
              if(data == "CARS"){
                return "EXOTIC AUTOMOBILES"
              }
              if(data=="HANDBAGS"){
                return "DESIGNER HANDBAGS"
              }
              if(data=="VINTAGE WINE SPIRITS"){
                return "VINTAGE WINE"
              }
              else{
                return data
              }
          }
          const categoryMap = allcat.reduce((acc, c) => {
            acc[mapfun(c.code.replaceAll("_"," "))] = c;
            return acc;
          }, {});
        const stories = data.stories || [];

        const normalizedStories = stories.map(story => {
          let ncat = story.category
          ? story.category.trim().toLowerCase()
          : 'uncategorized';
          ncat = mapfun(ncat?.toUpperCase())

          return ({
          ...story,
          category: ncat,
          categoryColor: categoryMap[ncat]?.color || '#CCCCCC',
        })});

        setInsights(normalizedStories);
        setAllInsights(normalizedStories);
        const map = {};
        normalizedStories.forEach(s => {
          map[s.category] = (map[s.category] || 0) + 1;
        });

        setCategories([
          { id: 'all', name: 'All', count: normalizedStories.length },
          ...Object.entries(map).map(([key, count]) => ({
            id: key,
            name: key.charAt(0).toUpperCase() + key.slice(1),
            count,
            categoryColor: categoryMap[key]?.color || '#CCCCCC',
          })),
        ]);
        setLoading(false)
        fetchNewsData([],mapfun,categoryMap);
      })
      .finally(() => setLoading(false));
  }, []);

  const InsightPopup = ({ story, onClose }) => (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✕</button>

        <div className="card-header">
          <span className="card-tag">{story.ticker}</span>
          <span className="card-date">{story.published_date}</span>
        </div>

        <h2 className="card-title">{story.indexName}</h2>

        <div
          className="card-description"
          dangerouslySetInnerHTML={{
            __html: story.story?.body || story.content,
          }}
        />

        <div className="card-footer">
          <span className="card-index">{story.category}</span>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (selectedCategory === 'all') {
      setInsights(Allinsights);
    } else {
      setInsights(
        Allinsights.filter(i => i.category === selectedCategory)
      );
    }
  }, [selectedCategory, Allinsights]);


  const fetchNewsData = async (data,mapfun,categoryMap) => {
    try {
      let body ={
        "from": new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
        "to":new Date().toISOString().split('T')[0],
        "filters": data
      }
      const response = await apis.getInsights(body);

      let news = mapStoriesToHeadlineItems(response.data.stories,mapfun,categoryMap);
      console.log("Mapped News:", news);
      setMarketNews(news);
      setAllInsights2(news);
      const map = {};
      news.forEach(s => {
        map[s.category] = (map[s.category] || 0) + 1;
      });

      setCategories2([
        { id: 'all', name: 'All', count: news.length },
        ...Object.entries(map).map(([key, count]) => {
          console.log("Category Key:", key, "Count:", count);
          return({
          id: key,
          name: key,
          count,
          categoryColor: categoryMap[key]?.color || '#CCCCCC',

        })}),
      ]);
      setLoading2(false);

    } catch (error) {
      if (error.response?.status === 404) {
        alert("Error occurred while stories " + error.response.data.message);
      } else {
        console.error("Error:", error);
        alert("Error occurred while fetching stories");
      }
    } finally {
      setLoading(false);
    }
  };

  const formatPublishedDate = (dateStr) => {
    if (!dateStr) return '';
  
    const date = new Date(dateStr);
    const now = new Date();
  
    // normalize to date-only
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
  
    const itemDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
  
    // ✅ Today → show time
    if (itemDate.getTime() === today.getTime()) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }
  
    // ✅ Yesterday
    if (itemDate.getTime() === yesterday.getTime()) {
      return 'Yesterday';
    }
  
    // ✅ Older → show date
    return date.toLocaleDateString([], {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  function mapStoriesToHeadlineItems(items = [],mapfun,categoryMap) {
    return items.map((item, index) => {
      // Extract headline from markdown body
      const body = item?.story?.body || '';
      const headlineMatch = body.match(/^#\s+(.*)/m);
      const headline = headlineMatch ? headlineMatch[1].trim() : '';
      const sourceurl = item.evidence_ref?.source_urls[0] || ""
      const category = item?.story?.classification?.asset_class || 'other';
      // Extract source from filters
      const sourceFilter = item.filters?.find(f => f.key === 'auction_house');
      const source = sourceFilter?.allowed?.[0] || '';
      let ncat = mapfun(category?.toUpperCase().replaceAll("_"," "))

      return {
        id: item.story_id ?? index + 1,
        date: formatPublishedDate(item.published_date) || '',
        headline,
        source,
        sourceurl,
        category:ncat,
        body,
        categoryColor: categoryMap[ncat]?.color || '#CCCCCC',
      };
    })
    // .filter(item=>item.category);
  }
  const map =(data)=>
    {
        if(data == "ALL"){
          return "ALL"
        }
        if(data == "NFT"){
          return "NFT"
        }
        if(data == "ART"){
          return "ART"
        }
        if(data == "COLLECTIBLES"){
          return "SECURITIZED COLLECTIBLES"
        }
        if(data == "WATCHES"){
          return "LUXURY TIMEPIECES"
        }
        if(data == "CARS"){
          return "EXOTIC AUTOMOBILES"
        }
        if(data=="HANDBAGS"){
          return "DESIGNER HANDBAGS"
        }
        else{
          return data
        }
    }

  if ((selType == "reports"&& loading) || (selType == "insights"&& loading2)) {
    return (
      <div style={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '10px solid rgba(255,255,255,0.2)',
            borderTop: '10px solid #F4A31E',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}
        />
      </div>
    );
  }


  return (
    <div className="luxury-dashboard">
      <section className="insights-section">
        <div style={{flexDirection:'row',display:'flex',justifyContent:'space-between',width:'100%',flexWrap:'wrap',marginBottom:40}}>
          <div>
            <h1 className="section-title">Intelligence</h1>
            <p className="subtitle">Data-driven reports, highlights and more</p>
          </div>

          <div style={{display:'flex',alignItems:'center',gap:10,marginTop:20,marginBottom:20}}>
            <span style={{color:selType=='reports'&&"orange"}}>Reports</span>

            <label class="switch">
              <input type="checkbox" onChange={(e) => setSeltype(e.target.checked?'insights':'reports')} />
              <span class="slider"></span>
            </label>

            <span style={{color:selType=='insights'&&"orange"}}>Insights</span>
          </div>
        </div>
       
        {/* Reports & Insights */}
        {/* <hr style={{marginBottom:30,marginTop:30}}/> */}
      

        {/* <hr style={{marginBottom:30,marginTop:30}}/> */}

        {selType=="reports"&&(<div>

          <div className="section-title" style={{fontSize:32}}>Luxury Market Reports</div>
          <p className="subtitle">Monthly reports on luxury brands</p>
          
          <div className="category-filters" style={{marginTop:40}}>
            {categories.map(cat => (
              <button
                key={cat.id}
                className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
                onClick={() => {
                  setInsights([]);
                  setSelectedCategory(cat.id)
                  let arr = Allinsights.filter( i => i.category === cat.id)  
                  if(cat.id === 'all'){
                    arr = Allinsights
                  }
                  console.log(arr)
                  setInsights(arr)    
                }}
                style={{fontSize:12,
                  ...selectedCategory != cat.id&&{
                  backgroundColor: `${cat.categoryColor}22`,
                  color: cat.categoryColor,
                  borderColor: `${cat.categoryColor}`,
                }}}
              >
                {map(cat?.name?.toUpperCase().replaceAll('_',' '))}
                {/* <span className="filter-count">{cat.count}</span> */}
                <span className="filter-count" style={{...selectedCategory != cat.id&&{color:cat.categoryColor}}}>{cat.count}</span>
              </button>
            ))}
          </div>

          <div className="insights-grid">
            {insights.map((item,i) => (
              <div
                key={i}
                className="insight-card"
                onClick={() => setActiveStory(item)}
              >
                <div className="card-header">
                  <span className="card-tag">{item.ticker}</span>
                  <span className="card-date">{item.published_date}</span>
                </div>

                <h3 className="card-title" style={{marginTop:20,marginBottom:20}}>{item.indexName}</h3>

                <div
                  className="card-description"
                  dangerouslySetInnerHTML={{
                    __html: (item.content || '').slice(0, 160) + '...',
                  }}
                />

                {/* <div className="card-footer">
                  <span className="card-index">{item.category?.toUpperCase()}</span>
                </div> */}
                  <div
                className="category-badge"
                style={{
                  backgroundColor: `${item.categoryColor}22`,
                  color: item.categoryColor,
                  borderColor: `${item.categoryColor}`,
                  // position:'absolute',
                  // top:0,left:10,
                  // fontSize:10,
                  justifyContent:'center',
                  alignItems:'center'
                }}
              >
            
                <span style={{color:`${item.categoryColor}`}}>{item.category}</span>
              </div>
              </div>
            ))}
          </div>
        </div>)}

        {selType=="insights"&&(<div>
          <div className="section-title" style={{fontSize:32}}>Online Auction Highlights</div>
          <p className="subtitle">Information on upcoming auctions and results</p>

          <div className="category-filters" style={{marginTop:40}}>
            {categories2.map(cat => (
              <button
                key={cat.id}
                className={`filter-btn ${selectedCategory2 === cat.id ? 'active' : ''}`}
                onClick={() => {
                  setMarketNews([]);
                  setSelectedCategory2(cat.id)
                  let arr = Allinsights2.filter( i => i.category === cat.id)  
                  if(cat.id === 'all'){
                    arr = Allinsights2
                  }
                  console.log(arr)
                  setMarketNews(arr)    
                }}
                style={{fontSize:12,
                  ...selectedCategory != cat.id&&{
                  backgroundColor: `${cat.categoryColor}22`,
                  color: cat.categoryColor,
                  borderColor: `${cat.categoryColor}`,
                }}}
              >
                {map(cat.name.toUpperCase().replaceAll('_',' '))}
                {/* <span className="filter-count">{cat.count}</span> */}
                <span className="filter-count" style={{...selectedCategory != cat.id&&{color:cat.categoryColor}}}>{cat.count}</span>
              </button>
            ))}
          </div>


          <div className="news-table">
            <div className="news-table-header">
              <div className="col-time">DATE</div>
              <div className="col-headline">HIGHLIGHTS</div>
              {/* <div className="col-source">SOURCE</div> */}
            </div>

            <div className="news-table-body">
              {marketNews.map((news) => {
                const isOpen = openId === news.id;
                return(
                <div  key={news.id} className="news-row">
                  <div className="col-time">{news.date}</div>
                  {/* <div 
                  onClick={()=>window.open(news.sourceurl, '_blank', 'noopener,noreferrer')} className="col-headline"
                  >
                    {news.headline}
                  </div> */}
                  {/* <div className="col-source">{news.source}</div> */}
                  <div>
                    <button
                      className="headline-btn col-headline"
                      onClick={() => setOpenId(isOpen ? null : news.id)}
                    >
                      <span style={{maxWidth:'80%'}}>{news.headline}</span>
                      <div>
                        {window.innerWidth>800&&(
                          <div
                          className="category-badge"
                          style={{
                            marginTop:'10px',
                            marginRight:20,
                            backgroundColor: `${news.categoryColor}22`,
                            color: news.categoryColor,
                            borderColor: `${news.categoryColor}`,
                            // position:'absolute',
                            // top:0,left:10,
                            fontSize:10,
                            justifyContent:'center',
                            alignItems:'center'
                          }}
                        >
                      
                          <span style={{color:`${news.categoryColor}`}}>{news.category}</span>
                        </div>)}
                        <span className={`chevron ${isOpen ? 'open' : ''}`}>▾</span>
                      </div>
                    </button>

                    {isOpen && (
                      <article className="news-article">
                        {/* {news.body} */}
                        {window.innerWidth<800&&(
                          <div
                          className="category-badge"
                          style={{
                            marginTop:'10px',
                            marginRight:20,
                            backgroundColor: `${news.categoryColor}22`,
                            color: news.categoryColor,
                            borderColor: `${news.categoryColor}`,
                            // position:'absolute',
                            // top:0,left:10,
                            fontSize:10,
                            justifyContent:'center',
                            alignItems:'center'
                          }}
                        >
                      
                          <span style={{color:`${news.categoryColor}`}}>{news.category}</span>
                        </div>)}
                        <ReactMarkdown>{news.body}</ReactMarkdown>
                      </article>
                    )}
                  </div>
                </div>
              )})}
            </div>
          </div>
        </div>)}
        
      </section>

      {activeStory && (
        <InsightPopup
          story={activeStory}
          onClose={() => setActiveStory(null)}
        />
      )}
    </div>
  );
};

export default Insights;